import { render } from "./TopCategoriesTableCard.vue?vue&type=template&id=0829f95d"
import script from "./TopCategoriesTableCard.vue?vue&type=script&lang=js"
export * from "./TopCategoriesTableCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TopCategoriesTableCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0829f95d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0829f95d', __exports__)) {
    console.log('reload')
    api.reload('0829f95d', __exports__)
  }
  
  module.hot.accept("./TopCategoriesTableCard.vue?vue&type=template&id=0829f95d", () => {
    console.log('re-render')
    api.rerender('0829f95d', render)
  })

}


export default __exports__